import styled from "@emotion/styled";
import { Colors, Spacing } from "@snapchat/snap-design-system";

export const LensListHeaderSection = styled.div<{ scrollbarWidth?: number }>`
    display: flex;
    flex-shrink: 0;

    padding: ${Spacing.MD}px ${Spacing.LG}px;
    padding-right: ${({ scrollbarWidth = 0 }) => scrollbarWidth + Spacing.LG}px;

    border-bottom: 1px solid ${Colors.Gray.V100};
`;
